import { Avatar, Col, Row } from 'antd';
import React, { PureComponent } from 'react';
import injectSheet from 'react-jss';
import ReactMarkdown from 'react-markdown';


const styles = () => ({
  root: {
    padding: '1em 0',
  },
  avatar: {
    width: '8em',
    height: '8em',
    lineHeight: '4em',
    borderRadius: '6em',
  },
  content: {
    padding: '1em 0',
  },
  description: {
    textAlign: 'justify',
  },
  bwImg: {
    filter: 'grayscale(100%)',
    '-webkit-filter': 'grayscale(100%)',
    '-moz-filter': 'grayscale(100%)',
    '-ms-filter': 'grayscale(100%)',
    '-o-filter': 'grayscale(100%)',
  },
});

class Presentation extends PureComponent {
  render() {
    const {
      classes, id, title, img, text, backgroundColor, imgStyle,
    } = this.props;

    return (
      <Row justify="center" type="flex" style={{ backgroundColor }}>
        <Col span={18} id={id} className={classes.root}>
          <Row>
            <h1>{title}</h1>
          </Row>
          <Row className={classes.content} justify="center" type="flex" gutter={12}>
            <Col md={6}>
              <Avatar className={`${classes.avatar} ${classes[imgStyle]}`} src={img} />
            </Col>
            <Col md={18} style={{ textAlign: 'justify' }}>
              <ReactMarkdown linkTarget="_blank" source={text} />
            </Col>
          </Row>
        </Col>
      </Row>
    );
  }
}

export default injectSheet(styles)(Presentation);



// WEBPACK FOOTER //
// ./src/app/pages/home/components/Presentation.jsx